import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NotificationPlacement, NotificationService } from '@services/notification.service';
import { map, Observable } from 'rxjs';

@Component({
	selector: 'app-floatingitems',
	templateUrl: './floatingitems.component.html',
	styleUrls: ['./floatingitems.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class FloatingitemsComponent {
	public placement$: Observable<NotificationPlacement> = this.notificationService.floatingMessages$.pipe(map((items) => items[0]?.placement));

	public impaired$: Observable<boolean> = this.notificationService.floatingMessages$.pipe(map((items) => items.some((item) => item.impaired)));

	constructor(public notificationService: NotificationService) {}
}
